module.exports = __webpack_public_path__ + "img/14-min.ebe1e059.png";